import React__default__default, { Children } from 'react';

/**
 * Returns `true` if `child` is a `React.Fragment`.
 * @param {ReactElement} child
 * @returns boolean
 */
const isFragment = child => child && child.type === React__default__default.Fragment;

/**
 * Returns element's displayName, name or type depending on what is given.
 * @param {any} element
 * @returns Element's displayName, name or type
 */
const getElementName = element => {
  if (element && element.type) {
    return element.type.displayName ? element.type.displayName : element.type.name || element.type;
  }
  return typeof element;
};

/**
 * Returns `true` if `child` is a valid component whose `displayName` matches
 * the given `displayName`.
 * @param {ReactElement} child
 * @param {string} displayName
 * @returns boolean
 */
const isOfType = (child, displayName) => /*#__PURE__*/React__default__default.isValidElement(child) && child.type.displayName ? child.type.displayName.includes(displayName) : false;

/**
 * Applies a function `fn` to an array of children. If a `React.Fragment` is found,
 * recursively applies the same function to its `children`.
 * @param {array} children
 * @param {function} fn
 * @returns array
 */
const mapRecursively = (children, fn) => Children.map(children, child => {
  if (isFragment(child)) {
    return Children.map(child.props.children, grandChild => /*#__PURE__*/React__default__default.isValidElement(grandChild) && fn(grandChild));
  }
  return /*#__PURE__*/React__default__default.isValidElement(child) ? fn(child) : child;
});

/**
 * Filters children based on displayName. Also iterates through Fragments recursively.
 * @param {array} children
 * @param {string} displayName
 * @returns A collection of children that has the provided displayName
 */
const getChildrenByName = (children, displayName) => {
  let filteredChildren = [];
  Children.forEach(children, child => {
    if (isFragment(child)) {
      const nestedChildren = getChildrenByName(child.props.children, displayName);
      filteredChildren = [...filteredChildren, ...nestedChildren];
    } else if (child && child.type.displayName === displayName) {
      filteredChildren.push(child);
    }
  });
  return filteredChildren;
};

/**
 * Strips down Injecss() HOC name from components
 * @param compName
 * @returns {*}
 */
const getUninjectedCompName = compName => compName.replace('Injecss(', '').replace(')', '');
var ReactUtils = {
  isFragment,
  getElementName,
  isOfType,
  mapRecursively,
  getChildrenByName,
  getUninjectedCompName
};

export { ReactUtils as default };
